import Vue from 'vue'
import Router from 'vue-router'
import store from "./store";
import {Message} from "element-ui";

Vue.use(Router)
const routes=[
    {
        path: '/',
        redirect: {
            name: 'login',
            component: () => import('./components/login.vue')
        },
        meta: {
            showInbreadcrumb: false
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('./components/login.vue'),
        meta: {
            showInbreadcrumb: false,
            keepAlive:true
        }
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('./components/register.vue'),
        meta: {
            showInbreadcrumb: false,
            keepAlive:true
        }
    },
    {
        path: '/pas',
        name: 'pas',
        component: () => import('./components/rePass.vue'),
        meta: {
            showInbreadcrumb: false,
            keepAlive:true
        }
    },
    {
        path:'/home',
        component: ()=>import('./components/layout/home.vue'),
        name:'home',
        redirect: '/home/newOrder',
        meta:{
            title:"首页",
            showInbreadcrumb:true
        },
        children:[
            {
                path: 'newOrder',
                name: 'newOrder',
                component: () => import('./components/newOrder'),
                meta: {
                    title: "提交工单",
                    showInbreadcrumb: true,
                    keepAlive:true
                },
            },
            {
                path: 'historyOrder',
                name: 'historyOrder',
                component: () => import('./components/historyOrder'),
                meta: {
                    title: "查询工单",
                    showInbreadcrumb: true,
                    keepAlive:true
                }
            },
            {
                path: 'index',
                name: 'index',
                component: () => import('./components/index'),
                meta: {
                    title: "知识条目",
                    showInbreadcrumb: true,
                    keepAlive:true
                }
            },
            // {
            //     path: 'detail',
            //     name: 'detail',
            //     component: () => import('./components/orderDetail'),
            //     meta: {
            //         title: "工单详情",
            //         showInbreadcrumb: false,
            //         keepAlive:false
            //     }
            // },
            // {
            //     path: 'my',
            //     name: 'my',
            //     component: () => import('./components/personal'),
            //     meta: {
            //         title: "我",
            //         showInbreadcrumb: true,
            //         icon:''
            //     },
            // }
        ]
    },
]
const router = new Router({
    // mode: 'history',
    routes
})
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
router.beforeEach((to,from,next)=>{
    if (to.path === '/login' || to.path === '/register' || to.path === '/pas') {
        next()
    }else{
        let id=store.state.id
        if(id){
            next()
        }else{
            next('/login')
        }
    }
})
export default router;
